import { render, staticRenderFns } from "./LogsListScreen.vue?vue&type=template&id=103b583a"
import script from "./LogsListScreen.vue?vue&type=script&lang=js"
export * from "./LogsListScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports